
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ContactoService {

    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) { }

    public obtener(codcont: number) {
        return this.httpClient.get(environment.serviceUrl + "contactos/" + codcont, { observe: 'response' },)
    }
    public getListCodigosClaseContacto(clase: number) {
        return this.httpClient.get(environment.serviceUrl + "contacto/clases/" + clase + "/codigos", { observe: 'response' },)
    }
    public getListClasesContacto() {
        return this.httpClient.get(environment.serviceUrl + "contacto/clases", { observe: 'response' },)
    }
    public insertContacto(contacto: any) {
        this.apiService.setUrlPathApi("contacto");
        return this.apiService.executePostJson(contacto).pipe();
    }
    public actualizar_contacto(contacto: any) {
        this.apiService.setUrlPathApi("contacto");
        return this.apiService.executePutJson(contacto).pipe();
    }
    public getContactoSearch(nombres: string, activos: boolean, limit: number, offset: number) {
        return this.httpClient.get(environment.serviceUrl + "contacto/buscar?nombres=" + encodeURI(nombres) + "&activos=" + activos + "&limit=" + limit + "&offset=" + offset, { observe: 'response' })
    }

    deleteContacto(codcont: any): Observable<any> {
        this.apiService.setUrlPathApi("contacto/");
        return this.apiService.executeDeleteJson(`${codcont}`);
    }
    
    /*
    getListClasesContacto() {
        return this.queryAjax.getQueryGet(contacto/clases);
    }
    */
    /*
    getListCodigosClaseContacto(clase: number) {
        return this.queryAjax.getQueryGet(contacto/clases/${clase}/codigos);
    }
    */
    /*
    getByIdContacto(codcont: number) {
        return this.queryAjax.getQueryGet(contacto/${codcont});
    }
    */

    //DELETE
    /*deleteContacto(codcont: number) {
        return this.queryAjax.getQueryDelete(contacto/${codcont});
    */

}